<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-11 08:57:14
 * @LastEditTime : 2023-11-07 11:22:48
 * @LastEditors  : yangxr
 * @Description  : 售料任务
 * @FilePath     : \icps_change\src\views\platform\ICPS\GHnumber\sellMaterialTask.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">车牌号</span>
              <el-input v-model="tableParam.carNo" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">站点名称</span>
              <el-input v-model="tableParam.stationName" style="width: 20%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">原物料名称</span>
              <el-input v-model="tableParam.rawName" style="width: 20%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">第二次过磅时间</span>
              <el-date-picker
                v-model="startTimDateEndTimDate"
                type="datetimerange"
                unlink-panels
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="(tableParam.startTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"
              ></el-date-picker>
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), ((disabledType = false), (isUpdate = false))">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <div v-if="item.label == '第一次过磅照片'">
                      <el-button size="mini" class="bottom_one" @click="look1Fun(scope.row.firstPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '第二次过磅照片'">
                      <el-button size="mini" class="bottom_one" @click="look1Fun(scope.row.secondPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '状态'">
                      <span>{{ dataStatusList[scope.row.dataStatus * 1] }}</span>
                    </div>
                    <div v-else-if="item.label == '操作'">
                      <el-button v-if="!scope.row.secondTime" size="mini" class="bottom_one" @click="updateFromDate(scope.row, '修改')">修改</el-button>
                      <el-button v-if="scope.row.secondTime && scope.row.dataStatus != 4" size="mini" class="bottom_one" @click="writeOff(scope.row)">冲销</el-button>
                      <el-button v-if="!scope.row.secondTime" size="mini" class="bottom_two" style="margin-left: 10px" @click="deleteSellRawMaterials(scope.row.id)"> 删除 </el-button>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" :disabled="disabledType" hide-required-asterisk :rules="rules">
          <el-form-item prop="stationId" :rules="[{ required: true, message: '请选择站点', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">站点</span>
            <el-select
              ref="selection2"
              v-model="fromDate.stationId"
              :disabled="isUpdate"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.stationName = $refs.selection2.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in stationIdlist" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="rawId" :rules="[{ required: true, message: '请选择原物料', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">原物料</span>
            <el-select
              ref="rawId"
              v-model="fromDate.rawId"
              :disabled="isUpdate"
              placeholder="请选择"
              filterable
              @change="
                $nextTick(() => {
                  fromDate.rawName = $refs.rawId.selectedLabel;
                }),
                  getWarehouseList()
              "
            >
              <el-option v-for="(item, index) in rawNameList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carNo" :rules="[{ required: true, message: '请输入车牌号', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">车牌号</span>
            <el-input v-model="fromDate.carNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="warehouseId">
            <span slot="label">库存仓</span>
            <el-select
              ref="warehouseId"
              v-model="fromDate.warehouseId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  fromDate.warehouseName = $refs.warehouseId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">收货方</span>
            <el-input v-model="fromDate.shipTo" style="width: 320px" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否补单</span>
            <el-radio-group v-model="fromDate.supplementaryOrdersStatus">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span style="margin-left: 40px">补单仅用作无人值守异常任务关联，正常任务则为否。</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="disabledType" class="bottom_all_two" @click="resetFromDate">关 闭</el-button>
        <el-button v-show="!disabledType" class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button v-show="!disabledType && !isUpdate" class="bottom_all" style="margin-left: 24px" @click="submit()">确 定</el-button>
        <el-button v-show="!disabledType && isUpdate" class="bottom_all" style="margin-left: 24px" @click="submit2()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="writeOffDig" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 冲销 </span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" hide-required-asterisk>
          <el-form-item>
            <span slot="label">冲销备注</span>
            <el-input v-model="fromDate.remark" :rows="5" resize="none" style="width: 320px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="writeOffDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveWriteOff()">确 定</el-button>
      </span>
    </el-dialog>
    <lookPicture :visible.sync="lookPictureDig" :urlList="urlList" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, saveOrUpdate, deleteSellRawMaterials, queryWarehouseList, queryRawNameList, updatSellRawMaterials, backSellRawMaterials } from "@/api/GHnumber/sellMaterialTask.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  components: {
    lookPicture: () => import("@/components/File/lookPicture.vue"),
  },
  data() {
    return {
      disabledType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      loading: false,
      /*表格数据*/
      table: [
        {
          label: "任务编号",
          width: "",
          prop: "id",
          status: true,
        },
        {
          label: "车牌号",
          width: "",
          prop: "carNo",
          status: true,
        },
        {
          label: "站点名称",
          width: "",
          prop: "stationName",
          status: true,
        },
        {
          label: "原物料",
          width: "",
          prop: "rawName",
          status: true,
        },
        {
          label: "库存仓",
          width: "",
          prop: "warehouseName",
          status: true,
        },
        {
          label: "收货方",
          width: "",
          prop: "shipTo",
          status: true,
        },
        {
          label: "创建时间",
          width: "",
          prop: "createTime",
          status: true,
        },
        {
          label: "第一次过磅时间",
          width: "",
          prop: "firstTime",
          status: true,
        },
        {
          label: "第一次过磅量（吨）",
          width: "",
          prop: "firstWeight",
          status: true,
        },
        {
          label: "第一次过磅照片",
          width: "",
          prop: "firstPictureUrl",
          status: true,
        },
        {
          label: "第二次过磅时间",
          width: "",
          prop: "secondTime",
          status: true,
        },
        {
          label: "第二次过磅量（吨）",
          width: "",
          prop: "secondWeight",
          status: true,
        },
        {
          label: "第二次过磅照片",
          width: "",
          prop: "secondPictureUrl",
          status: true,
        },
        {
          label: "确认售料量（吨）",
          width: "",
          prop: "sellMaterialsNum",
          status: true,
        },
        {
          label: "状态",
          width: "",
          prop: "dataStatus",
          status: true,
        },
        {
          label: "冲销备注",
          width: "",
          prop: "remark",
          status: true,
        },
        {
          label: "操作",
          width: "240",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      fromDate: {
        carNo: "",
        stationId: "",
        stationName: "",
        rawId: "",
        rawName: "",
        warehouseId: "",
        warehouseName: "",
        shipTo: "",
        supplementaryOrdersStatus: 0,
      },
      startTimDateEndTimDate: [],
      stationIdlist: [],
      urlList: [],
      lookPictureDig: false,
      warehouseList: [],
      rawNameList: [],
      dataStatusList: ["", "装料中（新任务）", "运输中（一次过磅后）", "已完成（二次过磅后）", "冲销"],
      isUpdate: false,
      writeOffDig: false,
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.stationIdlist = await getUserAutList(true);
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, dataSource: 1, carNo: "", stationName: "", rawName: "", startTime: "", endTime: "" };
    queryRawNameList().then(res => {
      this.rawNameList = res.data;
    });
    this.gettableData();
  },
  methods: {
    updateFromDate(data, text) {
      this.addDialog = true;
      setTimeout(() => {
        this.$refs.reffromDate.clearValidate();
      }, 10);
      this.fromDate = Object.assign({}, this.fromDate, data);
      this.addDialogTitle = text;
      this.disabledType = false;
      this.isUpdate = true;
      this.getWarehouseList();
    },
    saveWriteOff() {
      let obj = {
        id: this.fromDate.id,
        remark: this.fromDate.remark,
      };
      backSellRawMaterials(obj).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.gettableData();
          this.writeOffDig = false;
        }
      });
    },
    writeOff(row) {
      this.fromDate = Object.assign({}, this.fromDate, row);
      this.writeOffDig = true;
    },
    lookPicture(imgUrl) {
      this.lookPictureDig = true;
      this.urlList = imgUrl ? imgUrl.split(",") : [];
    },
    getWarehouseList() {
      if (!this.fromDate.stationId) {
        this.$message.warning("请选择站点!");
        return;
      }
      queryWarehouseList({
        rawId: this.fromDate.rawId,
        stationId: this.fromDate.stationId,
      }).then(res => {
        this.warehouseList = res.data;
      });
    },
    look1Fun(e) {
      this.lookPictureDig = true;
      this.urlList = e ? e.split(",") : [];
      this.urlList.forEach((item, index) => {
        this.urlList[index] = "/file/" + item;
      });
    },
    deleteSellRawMaterials(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteSellRawMaterials({ id: id }).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    init() {
      /*重置数据*/
      this.tableParam = { ...this.tableParam, dataSource: 1, carNo: "", stationName: "", rawName: "", startTime: "", endTime: "" };
      this.gettableData();
    },
    submit() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submit2() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          updatSellRawMaterials(this.fromDate).then(res => {
            this.loading = false;
            this.submitLoading = false;
            if (res.code === 1001) {
              this.resetFromDate();
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.gettableData();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_top {
  color: #008000;
}
.table_top:hover {
  color: #008000 !important;
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 320px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    background: #ffffff;
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.no-data {
  text-align: center;
}
.FZY ::v-deep .el-input-group__append {
  padding: 0px 8px;
}
.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}
</style>